import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PanarottisIcon from '../../data/PanaImages/PanarottisIcon.png';
import CounterPaymentImage from '../../data/PanaImages/CounterPayment.png';
import { setCurrentScreen, setOrderMetadata, submitCart, clearCart, setLoyaltyCode } from '../../store/orderSlice';
import { AppDispatch, RootState } from '../../store';

const nexaRustStack = '"Nexa Rust Sans Black A", "Museo Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

function orderNumberFromOrderId(orderId: string): string {
  return orderId.slice(-5).toUpperCase();
}

const PayAtCounterScreen: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const orderNumber = useSelector((state: RootState) => state.order.currentOrderNumber);
  const cartId = useSelector((state: RootState) => state.order.cartId);
  const isSubmittingCart = useSelector((state: RootState) => state.order.isSubmittingCart);
  const submitError = useSelector((state: RootState) => state.order.error);

  useEffect(() => {
    if (!cartId) {
      dispatch(setCurrentScreen('welcome'));
      return;
    }
    const submit = async () => {
      try {
        const { orderId } = await dispatch(submitCart(cartId)).unwrap();
        dispatch(setOrderMetadata({ orderNumber: orderNumberFromOrderId(orderId), timestamp: new Date().toISOString() }));
        dispatch(setCurrentScreen('success'));
      } catch {
        // Error is already stored in redux; remain on this screen to show message.
      }
    };
    submit();
  }, [dispatch, cartId]);

  useEffect(() => {
    if (!submitError) return;

    const timer = window.setTimeout(() => {
      dispatch(clearCart());
      dispatch(setLoyaltyCode(null));
      dispatch(setCurrentScreen('welcome'));
    }, 6000);

    return () => window.clearTimeout(timer);
  }, [dispatch, submitError]);

  return (
    <div
      className="min-h-screen bg-[#f2f1ec] flex flex-col items-center px-10 pt-12 pb-12"
    >
      <img
        src={PanarottisIcon}
        alt="Panarottis"
        className="w-[100px] h-[75.76px] object-contain"
      />

      <h1
        className="mt-12 text-center uppercase text-[#185C53] max-w-[1080px]"
        style={{
          fontFamily: nexaRustStack,
          fontSize: '80px',
          lineHeight: '88px',
          fontWeight: 900,
          letterSpacing: '2px',
        }}
      >
        Order <span style={{ color: '#00A294' }}>#{orderNumber ?? '-----'}</span>
        <br />
        Take your receipt to the counter
      </h1>

      {isSubmittingCart && (
        <div className="mt-8 w-16 h-16 border-4 border-[#00A294] border-t-transparent rounded-full animate-spin" aria-hidden />
      )}
      {submitError && (
        <p className="mt-6 text-center text-red-600 font-medium" style={{ fontFamily: nexaRustStack }}>
          {submitError}
        </p>
      )}

      <img
        src={CounterPaymentImage}
        alt="Take your receipt to the counter"
        className="mt-20 w-[500px] h-[519.01px] object-contain"
      />
    </div>
  );
};

export default PayAtCounterScreen;

